import { createAction } from "@reduxjs/toolkit";
export const logOut = createAction("user/logout");

export const response = createAction("response");
export const clearMessage = createAction("clear/message");
export const raiseError = createAction("raise/error");
export const emptyCart = createAction("empty/cart");
export const registerError = createAction("register/error");
export const addProductAction = createAction("/addProduct");
export const editProductAction = createAction("/editProduct");
export const deleteProductAction = createAction("/deleteProduct");
